// extracted by mini-css-extract-plugin
export default {"root":"PillSelect_root__BhOiU","pill":"PillSelect_pill__LGgmd","selected":"PillSelect_selected__T+162","disabled":"PillSelect_disabled__2+A8H"};